export default "__VITE_ASSET__C60h6Jys__"